import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const crossCheckService = createApi({
    reducerPath: "crossCheckService",
    baseQuery: baseQuery,
    endpoints: (builder) => ({
      createPayment: builder.mutation<any, any>({
        query: (body: any) => ({
          url: `/cross-check/payment`,
          body,
          method: "POST",
          headers: {
            PageName: "Email Recipients Service",
          },
        }),
      }),
    })
});

export const {
    useCreatePaymentMutation,
  } = crossCheckService;